<template>
	<v-row>
		<v-col>


			<v-form v-if="this.partner" v-model="formIsValid.place" ref="placeForm">
				<ui-box :form="$refs.placeForm" new-forms>
					<form-title title="Place"></form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<venue-select
									v-model="admission.venue_id"
									:rules="rules.place"
								:venues="venues"
							></venue-select>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.details" ref="detailsForm">

				<ui-box :form="$refs.detailsForm" :eager="!!product.id" new-forms>

					<form-title title="Ticket Details">
						Let your customers know what’s included with their ticket as well as any
						restrictions.
					</form-title>

					<form-divider inner/>

					<!-- Admission name -->
					<v-row>
						<v-col>
							<v-text-field
									v-model="admission.name"
									class="rounded-lg required"
									hint="Ex: General Admission, Park Admission, etc."
									label="Name"
									outlined
									persistent-hint
									:rules="rules.name"
							></v-text-field>
						</v-col>
					</v-row>
					<!-- End: Admission name -->
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.short_information"
									:counter="1250"
									hide-details="auto"
									label="Description"
									outlined
									rows="4"
							/>
						</v-col>
					</v-row>
					<!-- End: Included -->
					<form-divider inner/>

					<!-- Restrictions -->
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.restrictions"
									:counter="1250"
									hide-details="auto"
									hint="If there are no restrictions on use for this offer, leave blank."
									label="Are there restrictions?"
									outlined
									persistent-hint
									rows="4"
							/>
						</v-col>
					</v-row>
					<!-- End: Restrictions -->

				</ui-box>

			</v-form>
			<form-divider inner/>
			<v-form v-model="formIsValid.dates" ref="datesForm">

				<ui-box :form="$refs.datesForm" :eager="!!product.id" new-forms>
					<form-title title="Event End Date">
						This is the final date and time a passholder will be able to scan for entry.
					</form-title>
					<!-- Restrictions -->
					<v-row>
						<v-col cols="12" sm="12" md="6" lg="4">
							<bw-date-time-picker
									v-model="admission.redemption_policy.ends.date"
									hide-details="auto"
									label="End Date"
									:required="true"
									:rules="rules.end_date"
									:tz="partner.timezone"
							></bw-date-time-picker>
						</v-col>
					</v-row>

				</ui-box>

			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.retail" ref="imageForm">

				<ui-box :form="$refs.imageForm" :eager="!!product.id" new-forms
								v-if="!!product.id || true">

					<form-title title="Product Hero Image"></form-title>

					<form-divider inner/>

					<v-row>
						<bw-image
								v-model="editingHero"
								class="rounded-lg"
								:cols="{lg: 6, md: 8, sm: 10}"
								:upload-assignment="'product'"
								:upload-assignment-id="admission.id"
						></bw-image>
					</v-row>

				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.details" ref="detailsForm" class="mb-8">

				<ui-box :form="$refs.detailsForm" :eager="!!product.id" new-forms>

					<form-title title="Highlights">

					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<wysiwyg-input
								v-model="admission.highlights"
								:counter="250"
								hide-details="auto"
								label="Highlights"
								outlined
								persistent-hint
								rows="4"
							/>
						</v-col>
					</v-row>

					<form-divider inner/>

					<form-title title="Learn More Description">
						Show on learn more page on checkout.
					</form-title>


					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.short_description"
									:counter="250"
									hide-details="auto"
									label="Learn More Description"
									outlined
									rows="4"
							/>
						</v-col>
					</v-row>

					<form-divider inner/>

					<form-title title="Allow Gifting">
						Allow gifting this product at checkout.
					</form-title>

					<v-row>
						<v-col>
							<v-switch
									v-model="admission.giftable"
									inset
									:items="[
											{ value: 1, text: 'Yes' },
											{ value: 0, text: 'No' }
									]"
									label="Allow Gifting"
							></v-switch>
						</v-col>
					</v-row>

					<form-divider inner/>

					<form-title title="Allow Transfer">
						This removes the product from the purchaser's mobile pass, and adds it to the
						recipient's mobile
						pass.
					</form-title>

					<v-row>
						<v-col>
							<v-switch
									v-model="admission.transferable"
									inset
									:items="[
											{ value: 1, text: 'Yes' },
											{ value: 0, text: 'No' }
									]"
									label="Allow Transfer"
							></v-switch>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<v-form v-model="formIsValid.details" ref="detailsForm" class="mb-8">

				<ui-box :form="$refs.detailsForm" :eager="!!product.id" new-forms>
					<form-title title="Ticket Limit">
						The amount of tickets available to sell. If left blank, ticket availability is
						unlimited.
					</form-title>

					<v-row>
						<v-col>
							<v-text-field
									v-model.number="ticketQuantity"
									class="mt-4 mt-sm-0 rounded-lg"
									hide-details="auto"
									label="Ticket Limit"
									min="0"
									outlined
									type="number"
									@wheel.native.prevent
							></v-text-field>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>


			<form-divider/>

			<v-form v-model="formIsValid.redeemForm" ref="redeemForm" class="mb-8">
				<ui-box :form="$refs.redeemForm" :eager="!!product.id" new-forms>

					<form-title title="How To Redeem">
						Where will your customers use this coupon and are there special instructions?
					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.ticket_dashboard_instructions"
									:counter="250"
									hide-details="auto"
									hint="Information the user should know before redeeming this offer"
									label="Pre-Redemption Instructions"
									outlined
									persistent-hint
									rows="4"
									:rules="rules.redemption_instructions"
							/>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>
			<v-form v-model="formIsValid.redeemForm" ref="redeemForm" class="mb-8">

				<ui-box :form="$refs.postRedeemForm" :eager="!!product.id" new-forms>

					<form-title title="Post Redemption Instructions">
						In order to be redeemed in person, who should the pass-holder present the
						coupon to in the
						establishment?
					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.redemption_settings.instructions"
									:counter="250"
									hide-details="auto"
									label="Post-Redemption Instructions"
									outlined
									rows="4"
									:rules="rules.redemption_instructions"
							/>
						</v-col>
					</v-row>


				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.retail" ref="retailForm" class="mb-8">
				<pricing-form :refs="$refs" :admission="admission" :form-is-valid="formIsValid"
							:origin="origin" :partner="partner"  :product="product" :rules="rules"/>
				<v-row>
					<v-col cols="12" sm="4">
						<form-title title="Convenience Fee"/>
						<v-row>
							<v-col cols="12" sm="5">
								<v-select
										v-model="admission.convenience_fee_type"
										class="rounded-lg"
										:items="[{name: '$', value: 'fixed'}, {name: '%', value: 'percent'}]"
										item-text="name"
										label="Fee type"
										outlined
										persistent-hint
								></v-select>
							</v-col>

							<v-col cols="12" sm="8">
								<v-text-field
										v-model.number="admission.convenience_fee"
										class="mt-4 mt-sm-0 rounded-lg"
										label="Convenience Fee"
										outlined
										persistent-hint
										type="number"
										@wheel.native.prevent
								></v-text-field>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="4">
						<form-title title="Tax Rate"/>
						<v-text-field
								v-model.number="admission.tax_rate"
								class="mt-4 mt-sm-0 rounded-lg"
								label="Tax Rate"
								outlined
								persistent-hint
								prefix="% "
								type="number"
								@wheel.native.prevent
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>

			<v-form v-model="formIsValid.refundPolicy" ref="redeemForm" class="mb-8">
				<ui-box :form="$refs.refundPolicy" :eager="!!product.id" new-forms>
					<form-title title="Refund Policy">
						Type in any specific refunding policy here. If none, this will default to
						Bandwango’s standard refund policy and terms of condition.
					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.refund_policy"
									:counter="250"
									hide-details="auto"
									label="Type in any specific refunding policy here."
									outlined
									rows="4"
									:rules="rules.refund_policy"
							/>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<v-form v-if="origin!='merchant-portal'" v-model="formIsValid.buttonLanguage" ref="buttonLanguageForm" class="mb-8">
				<button-language :refs="$refs" :product="product" :coupon="admission" :partner="partner" :form-is-valid="formIsValid"/>
			</v-form>

			<mobile-pass-preview-modal
					v-if="preview.url"
					:preview-url="preview.url"
					@accept-preview="acceptPreview"
					@reject-preview="rejectPreview"
			></mobile-pass-preview-modal>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					new-forms
					save-text="Save & Preview"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
			></save-form>
		</v-col>
	</v-row>
</template>

<script>
import {admissionHelpers, productHelpers} from '../helpers';
import {templateHelpers} from '../../../../templateHelpers';
import FormDivider from "../../../../UI/Form/FormDivider.vue";
import VenueSelect from '../Shared/VenueSelect.vue';
import ButtonLanguage from "../Shared/ButtonLanguage.vue";
import WysiwygInput from "../../../../Forms/WysiwygInput/index.vue";

export default {
	name: "EventTicketProductForm",
	components: {WysiwygInput, ButtonLanguage, FormDivider, VenueSelect },
	props: {
		// The incoming product from an edit
		product: {
			type: Object,
			default: () => ({})
		},
		template: {
			type: Object,
			default: () => ({})
		},
		venue: {
			type: Object,
			default: () => ({})
		},
		venues: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		},
		origin: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			admission: {
				...productHelpers.productFormat(this.product),
			},
			customFields: {
				bw_add_to_future_passes: {
					field_code: 'bw_add_to_future_passes',
					value: "Yes",
				}
			},
			formIsValid: {
				details: false,
				retail: false,
				availability: false
			},
			isSaving: false,
			preview: {
				product: {},
				url: undefined
			},
			rules: {},
			selectedAdmissionTemplate: productHelpers.getTemplate(this.product, this.template, this.template.childTemplates.map(t => t.id)),
			ticket: null,
		}
	},
	mounted() {
		this.rules = admissionHelpers.getValidationRules(this.$data);

		templateHelpers.loadCustomFields(this.admission, this.customFields);
		this.pricingStrategy = this.admission?.attributes?.length > 0 ? 'tiers' : 'pricing';
		this.admission = {
			...this.admission,
			redemption_policy: {
				...this.admission.redemption_policy,
				ends: {
					...this.admission.redemption_policy?.ends,
					date: this.admission.redemption_policy?.ends?.date || '',
					type: 'date',
					hidden: false
				}
			}
		};
		this.ticket = this.admission?.tickets?.find(t => t.type === this.template.settings.ticket_values.type && !t.value);
		if(!this.ticket) {
			this.ticket = {
				...this.template.settings.ticket_values
			};
			const tickets = this.admission.tickets || [];
			tickets.push(this.ticket);
			this.$set(this.admission, 'tickets', tickets);
		}


	},
	computed: {
		editingHero: {
			get() {
				if(!this.admission) return;
				let m = this.admission.media.find(x => x.location === 'Hero');
				if(!m) {
					return {
						location: 'Hero',
						name: 'Hero',
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					};
				}
				return {
					...m,
					minDimensions: false,
					cropperSettings: m.cropperSettings || {
						limitAR: '2:1',
						x: 0,
						y: 0
					}
				};
			},
			set(v) {
				if(!this.admission) return;
				const index = this.admission.media.findIndex(x => x.location === 'Hero');
				if(index !== -1) {
					this.$set(this.admission.media, index, {
						...this.admission.media[index],
						...v,
						minDimensions: false,
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					});
				}
				else {
					this.admission.media.push({
						...v,
						location: 'Hero',
						minDimensions: false,
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					});
				}
			}
		},
		ticketQuantity: {
			get() {
				return this.ticket?.quantity || '';
			},
			set(v) {
				this.$set(this.ticket, 'quantity', !!v ? v : null);
			}
		},

	},
	methods: {
		acceptPreview() {
			productHelpers.acceptPreview(this.admission, 'Admission', this.preview, this.getReturnUrl());
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return productHelpers.getReturnUrl(this.returnUrl, this.partner, this.venue);
		},

		rejectPreview() {
			this.isSaving = false;
			this.preview.url = undefined;
		},
		saveChanges() {
			this.admission.customFields = Object.values(this.customFields);
			this.admission.template_id = this.template.id;

			productHelpers.saveChanges(this.isSaving, this.partner, this.venue, this.admission, this.preview);

		},

	},

};
</script>
